// Autogenerated by script
import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

export const SparkasseLogo: typeof SvgIcon & { activeColor: string } = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="M10.399 3.03A2.183 2.183 0 0 1 12 2.363c.623 0 1.156.223 1.601.667.445.445.667.979.667 1.601 0 .623-.222 1.162-.667 1.617A2.162 2.162 0 0 1 12 6.932a2.152 2.152 0 0 1-1.601-.684 2.24 2.24 0 0 1-.667-1.617c0-.621.222-1.155.667-1.6ZM5.098 17.002h10.537v-1.367H5.098v-5.068c0-.556.239-1.073.717-1.55.478-.479 1.017-.718 1.617-.718h9.137c.578 0 1.112.223 1.601.667.49.445.734.979.734 1.601v.9H8.367v1.367h10.537v5.102c0 .6-.228 1.128-.684 1.584a2.25 2.25 0 0 1-1.651.684H7.432c-.645 0-1.195-.205-1.651-.617-.456-.411-.684-.961-.684-1.65v-.935h.001Z" />
  </SvgIcon>
);

SparkasseLogo.activeColor = 'inherit';
SparkasseLogo.muiName = 'SparkasseLogo';
